<template>
  <div>
    <file-system-chart />
  </div>
</template>
<script>
import FileSystemChart from './charts/FileSystemChart.vue'

export default {
  name: 'HostDetailsMemory',
  components: { FileSystemChart },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
}
</script>
